import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputGroup,
  InputLeftElement as ChakraInputLeftElement,
  InputRightElement as ChakraInputRightElement,
  Textarea as ChakraTextarea,
  TextareaProps,
} from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FieldError } from 'react-hook-form';
import { BsInfoCircle } from 'react-icons/bs';
import PopoverCustom from '../Generic/Popover';

export interface IProps extends TextareaProps {
  name: string;
  label?: string;
  error?: FieldError;
  isRequired?: boolean;
  InputLeftElement?: any;
  InputRightElement?: any;
  activepopover?: boolean;
  popovericon?: any;
  popovertext?: string;
  popoverheader?: string;
}

const Textarea: ForwardRefRenderFunction<HTMLTextAreaElement, IProps> = (
  {
    label,
    name,
    error = null,
    isRequired,
    InputRightElement,
    InputLeftElement,
    mb,
    mt,
    activepopover,
    popovertext,
    popoverheader,
    ...rest
  },
  ref,
) => {
  return (
    <FormControl isInvalid={!!error} isRequired={isRequired} mb={mb} mt={mt}>
      <Flex alignItems="center">
        {!!label && <FormLabel htmlFor={name}>{label}</FormLabel>}
        {activepopover && (
          <PopoverCustom
            mb="2"
            icon={<BsInfoCircle />}
            headerText={popoverheader}
          >
            {popovertext}
          </PopoverCustom>
        )}
      </Flex>
      <InputGroup>
        {!!InputLeftElement && (
          <ChakraInputLeftElement>{InputLeftElement}</ChakraInputLeftElement>
        )}
        <ChakraTextarea
          name={name}
          id={name}
          focusBorderColor="brand.500"
          bgColor="gray.200"
          backgroundColor="#FFFFFF"
          _placeholder={{ color: '#000000' }}
          variant="filled"
          _hover={{ borderColor: 'brand.500' }}
          size="md"
          borderColor="gray.200"
          ref={ref}
          {...rest}
        />
        {!!InputRightElement && (
          <ChakraInputRightElement>{InputRightElement}</ChakraInputRightElement>
        )}
      </InputGroup>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export default forwardRef(Textarea);
